import React, {
  useEffect,
  useState,
  useRef,
  useContext
} from "react";
import searchIcon from "../../Assets/Images/search_black_24dp.svg";
import ApprovedReq from "./ApprovedReq";
import RejectedReq from "./RejectedReq";
import { MultiSelect } from "./MultiSelect";
import axios from "axios";
import { appconfig } from "../../resources/config";
import tableBg from "../../Assets/Images/Rectangle.svg"
import TreeView from './TreeView'
import EditUser from "./EditUser";
import { postData,getData } from "../../resources/utils";

const UsersList = ({ data, approvedUserListData, updateUserListData, rejectedUserListData }) => {
  const [searchInput, setSearchInput] = useState('');
  const [filteredData, setFilteredData] = useState(data);
  const [addNewUserForm, setAddNewUserForm] = useState(false);
  const [viewUserForm, setViewUserForm] = useState(false);
  const [deletUserForm, setDeletUserForm] = useState(false)
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [approveRejectUser, setApproveRejectUser] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);   
  const [showRejectUser, setShowRejectedUser] = useState(false);
  const [deleteUser, setDeleteUser] = useState(false);
  const [viewUser, setViewUser] = useState(false);
  const [viewEditModal, setEditModal] = useState(false);
  const [activeTab, setActiveTab] = useState('Pending');
  const [mobileNumberError, setMobileNumberError] = useState("");
  const [emailError, setEmailError] = useState("");
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const [mapLoader,setMapLoader] = useState(false)
  const [featureTypesList, setFeatureTypesList] = React.useState([]);

const [selectedLocation, setSelectedLocation] = useState({
  state: [],
  city: [],
  taluka: [],
  village: [],
  khasra: []
});
  const [inputUserData, setInputUserData] = useState({
    userName: "",
    userEmail: "",
    userMobile: "",
    userPassword: "",
    userConfirmPassword: "",
    userDesignation: "",
    userDepartment: "",
    userOtp: "",
    isMobileNumVerified: false,
    isReportDownload: false,
    isUserAdmin: false,
    isUser: true,
  userType: 2,
  userStatus: 1,
  });

const [selectedFeatureType, setSelectedFeatureType] = useState([]);
const [locationFiltersList, setLocationFiltersList] = useState({
  country: [],
  state: [],
  city: [],
  taluka: [],
  village: [],
  khasra: [],
});
const [dropdownLoader, setDropdownLoader] = useState({
  country:false,
  state: false,
  city: false,
  taluka: false,
  village: false,
  khasra: false
});

    // ----------------------FUNCTION FOR SEARCH USER BY NAME OR NUMBER--------------------
  const handleSearchInputChange = (e) => {
    setSearchInput(e.target.value);

    const filtered = data.filter((row) => {

    // const filtered = dummyData.filter((row) => {
      return (
        row.name.toLowerCase().includes(e.target.value.toLowerCase()) ||
        row.mobileNo.toLowerCase().includes(e.target.value.toLowerCase())

      );
    });

    setFilteredData(filtered);
  };

  const handleClick = (tab) => {
    setActiveTab(tab);
    updateUserListData()
  };
    const addUser = () => {
    setAddNewUserForm(true)
  }
    const closeAddUserForm = () => {
    setAddNewUserForm(false)
    
  }

    const closeBarModal = () => {
    setViewUserForm(false)
  }

  const handleSetUserForm = (value) => {
    setViewUserForm(value)
  }

  const setUserDetailFn = (user) => {
    setSelectedUser(user);
  }

    const deleteSelectedUser = () => {
    setDeletUserForm(true)
  }
  const closeDetetedForm = () => {
    setDeletUserForm(false)
  }

  const openApproveRejectUserModal = (user) => {
    setApproveRejectUser(true)
    setSelectedUser(user);
  }

  const closeAppproveRejectUserModal = () => {
    setApproveRejectUser(false)
    setSelectedUser(null);
  }
  const openRejectUserModal = (user) => {
    setShowRejectedUser(true)
    setSelectedUser(user);
  }

  const closeRejectUserModal = () => {
    setShowRejectedUser(false)
    setSelectedUser(null);
  }

  const openDeleteUserModal = (user) => {
    setDeleteUser(true)
    setSelectedUser(user);
  }

  const closeDeleteUserModal = () => {
    setDeleteUser(false)
    setSelectedUser(null);
  }

  const openViewUserModal = (user) => {
    // console.log('user', user);
    setSelectedUser(user);
    setViewUser(true)
    setSelectedUserId(user?.id)
  }

  const closeViewUserModal = () => {
    setViewUser(false)
    setSelectedUserId(null)
  }
  const openEditModal = (user) => {
    setEditModal(true)
    setSelectedUserId(user?.id)
    setSelectedUser(user);
  }

  const closeEditModal = () => {
    setEditModal(false)
    setSelectedUserId(null)
  }
  const handleLocationPayLoad = () => {
    return {
      type: "location",
      admin_id: userId,

      country_id: [1],

      state_id:
        selectedLocation.state.length > 0
          ? selectedLocation.state.map((s) => s.value)
          : ["*"],

      district_id:
        selectedLocation.city.length > 0
          ? selectedLocation.city.map((c) => c.value)
          : ["*"],

      taluk_id:
        selectedLocation.taluka.length > 0
          ? selectedLocation.taluka.map((t) => t.value)
          : ["*"],

      village_id:
        selectedLocation.village.length > 0
          ? selectedLocation.village.map((v) => v.value)
          : ["*"],

      khasra:
        selectedLocation.khasra?.length > 0
          ? selectedLocation.khasra.map((k) => k.value)
          : ["*"],
    };
  };
  const handleLogin = async () => {
    const data = {
      type: "",
      admin_id: userId,
      name: inputUserData.userName,
      email: inputUserData.userEmail,
      user_status: inputUserData.userStatus,
      user_type: inputUserData.userType,
      mobile_number: inputUserData.userMobile,
    };

    return await postData("agribhumi", "add_user", data, null);
  };

  const handleFeaturePayload = (userId) => ({
    type: "features_update",
    admin_id: userId,
    user_id: userId,
    feature_id:
      selectedFeatureType.length > 0
        ? selectedFeatureType.map((f) => f.value)
        : ["*"],
  });


  const handleChange = (fieldName, value) => {
    setInputUserData({
      ...inputUserData,
      [fieldName]: value,
    });

    if (fieldName === "userEmail") {
      if (!emailRegex.test(value)) {
        setEmailError("Please enter a valid email address.");
      } else {
        setEmailError("");
      }
    }

  };
const buildParams = (type, ids = [], keyName) => {
  let paramStr = `type=${type}`;

  if (Array.isArray(ids) && ids.length > 0 && keyName) {
    ids.forEach((id) => {
      if (id === "*") {
        paramStr += `&${keyName}[]=*`;
      } else {
        paramStr += `&${keyName}[]=${id}`;
      }
    });
  }

  return `admin/webp/agbi_multi_location.php?${paramStr}${getFeatureParams()}`;
};
// const getIdsOrAll = (val, options) => {
//   const safeVal = Array.isArray(val) ? val : [];
//   const safeOptions = Array.isArray(options) ? options : [];

//   if (safeVal.length === safeOptions.length) {
//     return ["*"];
//   }

//   return safeVal.map(v => v.value);
// };
const getIdsOrAll = (selectedValues, allOptions) => {
  if (!selectedValues || selectedValues.length === 0) {
    return "*";
  }

  // Select All selected
  if (
    selectedValues.some(item => item.value === "*") ||
    (allOptions.length > 0 &&
      selectedValues.length === allOptions.length)
  ) {
    return "*";
  }

  return selectedValues.map(item => item.value);
};

const getLocationList = async (params, key) => {
  setDropdownLoader(prev => ({ ...prev, [key]: true }));

  try {
    const res = await axios({
      method: "GET",
      url:
        appconfig.domain[appconfig.environment].agribhumi +
        params,
    });

    const safeData = Array.isArray(res?.data?.data)
      ? res.data.data
      : [];

    setLocationFiltersList((prev) => ({
      ...prev,
      [key]: safeData,
    }));

  } catch (err) {
    console.error("Location API Error:", err);

    setLocationFiltersList((prev) => ({
      ...prev,
      [key]: [],
    }));
  }

  setDropdownLoader(prev => ({ ...prev, [key]: false }));
};
  const getFeatureParams = () => {
    const selectedFeatures = selectedFeatureType.map(f => f.value);

    const farmFeatures = [
      "farm-report",
      "farmer-scorecard",
      "crop-history",
      "cadastral-data"
    ];

    const isFarm = selectedFeatures.some(f =>
      farmFeatures.includes(f)
    );

    return isFarm ? "&farm_check=1" : "";
  };

  const countryOptions = Array.isArray(locationFiltersList.country)
    ? locationFiltersList.country.map(item => ({
        label: item.country_name,
        value: item.country_id
      }))
    : [];

  const stateOptions = Array.isArray(locationFiltersList.state)
    ? locationFiltersList.state.map(item => ({
      label: item.state_name,
      value: item.state_code
    }))
    : [];

  const cityOptions = Array.isArray(locationFiltersList.city)
    ? locationFiltersList.city.map(item => ({
      label: item.district_name,
      value: item.district_code,
      group: item.group_id
    }))
    : [];

  const talukaOptions = Array.isArray(locationFiltersList.taluka)
    ? locationFiltersList.taluka.map(item => ({
      label: item.taluk_name,
      value: item.taluk_code,
    }))
    : [];

  const villageOptions = Array.isArray(locationFiltersList.village)
    ? locationFiltersList.village.map(item => ({
      label: item.village_name,
      value: item.agbr_village_code
    }))
    : [];

  const khasraOptions = Array.isArray(locationFiltersList.khasra)
    ? locationFiltersList.khasra.map(item => ({
      label: item.khasra,
      value: item.khasra
    }))
    : [];
  useEffect(() => {
    setFilteredData(data);
  }, [data]);

  const [loading, setLoading] = useState(false);
  const approveUserRequest = async (user, status) => {
    if (!user?.id) {
      return;
    }

  try {
    setLoading(true);
    const approveRejectParam = {
      type: "update_user",
      admin_id: Number(localStorage.getItem("user_id")) || 0,
  user_id: Number(user?.id) || 0,
  user_status: Number(status) || 0,
    };

    const approveResp = await postData(
      "agribhumi",
      "user_status_change",
      approveRejectParam,
      null
    );

      if (approveResp?.status === 200) {
        setViewUserForm(false);
        setApproveRejectUser(false);
        setShowRejectedUser(false);

        updateUserListData();

      } else {
      }
    } catch (err) {
      console.log("error", err);
    } finally {
      setLoading(false);
    }
  };
  
    useEffect(() => {
    const fetchFeatureTypes = async () => {
      try {
        const res = await getData(
          "agribhumi",
          "users_role",
          {
            user_id: localStorage.getItem("user_id"),
            type: "feature",   
          },
          null
        );
  
        const data = res?.data?.data || [];
  
        const formatted = data.map(item => ({
          label: item.feature_name || item.name,
          value: item.feature_id || item.id
        }));
  
        setFeatureTypesList(formatted);
  
      } catch (err) {
        console.log("Feature API Error:", err);
        setFeatureTypesList([]);
      }
    };
  
    fetchFeatureTypes();
  }, []);


  const getIdsOrStar = (selected, options) => {
  const safeSelected = Array.isArray(selected) ? selected : [];
  const safeOptions = Array.isArray(options) ? options : [];

  if (safeSelected.length === safeOptions.length && safeOptions.length > 0) {
    return ["*"];
  }

  return safeSelected.map(i => i.value);
};
 const [addUserLoadder, setAddUserLoadder] = useState(false);
const addNewUser = async () => {
  console.log("called");

  const {
    userName,
    userMobile,
    userEmail,
    userDepartment,
    userDesignation,
  } = inputUserData;

  if (
    !userName ||
    !userMobile ||
    !userEmail ||
    !userDepartment ||
    !userDesignation
  ) {
    console.error(" Required fields missing");
    return;
  }

   const isLocationOverride =
    selectedLocation.country?.length > 0 &&
    selectedLocation.state?.length > 0 &&
    selectedLocation.city?.length > 0 &&
    selectedLocation.taluka?.length > 0 &&
    selectedLocation.village?.length > 0 &&
    selectedLocation.khasra?.length > 0;

  if (!isLocationOverride) {
    console.error("Location fields missing");
    return;
  }

  setAddUserLoadder(true);

  try {
    const adminId = Number(localStorage.getItem("user_id"));
    const basicdetailpayload = {
      type: "add_user",
      admin_id: adminId,
      name: userName,
      mobile_number: Number(userMobile),
      email: userEmail,
      department: userDepartment,
      designation: userDesignation,
      user_status: inputUserData.userStatus,
      user_type: inputUserData.userType,
    };

    const userRes = await postData(
      "agribhumi",
      "add_user",   
      basicdetailpayload,
      null
    );
console.log('useref',userRes);

    const userId = userRes?.data?.data?.user_id || userRes?.data?.data?.id;

    if (!userId) {
      throw new Error(" User ID ---");
    }

   if (selectedFeatureType?.length > 0) {
  const featureAssignPayload = {
    type: "features_update",
    admin_id: adminId,
    user_id: userId,
    feature_id: getIdsOrStar(
      selectedFeatureType,
      featureTypesList
    ),
  };

  await postData(
    "agribhumi",
    "userfeature_and_location",
    featureAssignPayload,
    null
  );
}
    if (isLocationOverride) {
      const locationAssignPayload = {
        type: "location",
        admin_id: adminId,
        user_id: userId,
        country_id: getIdsOrStar(selectedLocation.country, countryOptions),
        state_id: getIdsOrStar(selectedLocation.state, stateOptions),
        district_id: getIdsOrStar(selectedLocation.city, cityOptions),
        taluk_id: getIdsOrStar(selectedLocation.taluka, talukaOptions),
        village_id: getIdsOrStar(selectedLocation.village, villageOptions),
        khasra: getIdsOrStar(selectedLocation.khasra, khasraOptions),
      };

      await postData(
       "agribhumi",
      "userfeature_and_location",
        locationAssignPayload,
        null
      );
    }

  } catch (error) {
    console.error("Error:", error);
    setAddNewUserForm(false)

  } finally {
    setAddUserLoadder(false);
      updateUserListData();
    setAddNewUserForm(false)
  }
};

  const deleteUserRequest = async (user) => {
    const adminId = Number(localStorage.getItem("user_id"));
    const deleteUserPayload = {
      type: "delete_user",
      admin_id: adminId,
      user_id: user.id
    }
    try {
      const userRes = await postData(
        "agribhumi",
        "add_user",
        deleteUserPayload,
        null
      );
      updateUserListData();
      setDeletUserForm(false);
      closeDeleteUserModal()

    }
    catch (err) {
      console.log("error", err);

    }
  }

  return (
    <div className="justify-center">

      <div className="flex justify-center h-[54px]">
        <input
          className="w-[36%] rounded-[7px] focus:outline-none pl-[30px] placeholder:text-[18px] bg-[#f3f3f3] text-[#636363] border-none"
          type="search"
          id="searchInput"
          placeholder="Enter the name or number to search the request."
          onChange={handleSearchInputChange}
        />

        <div className="ml-[1%] flex justify-center h-[51px]">
          <button className="bg-[#2f9ce6] text-[1.5rem] font-medium w-[11.25rem] h-[51px] rounded-[0.375rem] text-white">
            Search
          </button>
        </div>
      </div>
   
      <div className="flex justify-end mt-[2rem] mb-2 mr-[2%]">
        <button
          className="flex items-center gap-3 px-4 py-2 bg-[#f5f5f5] text-black text-[16px] text-semibold h-[50px] font-medium rounded-[0.375rem]"
          onClick={addUser}
        >
          Add New User
        </button>
      </div>

      <div className="w-[97%] m-auto overflow-hidden shadow-lg ">
        <div
          className="flex justify-between items-center px-6 h-[80px]"
          style={{
            backgroundImage: `url(${tableBg})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "cover",
            transform: "scaleY(-1)"
          }}
        >
          {/* <div className="flex w-[55%] justify-between scale-y-[-1] items-end h-full translate-y-[4px] pt-[7%] pb-[21px] "> */}
          <div className="flex justify-between scale-y-[-1] items-end h-full translate-y-[4px] pt-[7%] ">
            <p
              className={`cursor-pointer px-4 py-2 rounded-md text-[22px] transition-all duration-200
      ${activeTab === "Pending"
                  ? "text-black font-semibold "
                  : "text-white  hover:bg-white/10"
                }`}
              onClick={() => handleClick("Pending")}
            >
              Pending Requests ({data.length})
            </p>
            <p
              className={`cursor-pointer px-4 py-2 rounded-md text-[22px] transition-all duration-200
      ${activeTab === "Approved"
                  ? "text-black font-semibold "
                  : "text-white  hover:bg-white/10"
                }`}
              onClick={() => handleClick("Approved")}
            >
              Approved Requests ({approvedUserListData?.length})
            </p>

            <p
              className={`cursor-pointer px-4 py-2 rounded-md text-[22px] transition-all duration-200
      ${activeTab === "Rejected"
                  ? "text-black font-semibold "
                  : "text-white hover:bg-white/10"
                }`}
              onClick={() => handleClick("Rejected")}
            >
              Rejected Requests ({rejectedUserListData?.length})
            </p>
          </div>
        </div>

        {activeTab === "Pending" && (
          <div className="bg-white">

            <div className="max-h-[60vh] overflow-y-auto">
              <table className="w-full table-fixed">
                <thead className="bg-[#f5f5f5] sticky top-0 z-10">
                  <tr className="h-[70px]">
                    <th className="text-[#000] text-[18px] font-semibold w-[20%] text-left px-6">Name</th>
                    <th className="text-[#000] text-[18px] font-semibold w-[20%] text-left px-6">Mobile No</th>
                    <th className="text-[#000] text-[18px] font-semibold w-[20%] text-left px-6">Email</th>
                    <th className="text-[#000] text-[18px] font-semibold w-[20%] text-left px-6">Action</th>
                    <th className="text-[#000] text-[18px] font-semibold w-[20%] text-left px-6">Requested On</th>
                  </tr>
                </thead>
                <tbody>
                  {filteredData.map((row, index) => (
                    <tr
                      key={index}
                      className="border-b border-gray-200 hover:bg-[#f1f1f1]"
                    >
                      <td className="w-[20%] text-[#818589] text-[16px] px-6 py-3">{row.name ?? "--"}</td>
                      <td className="w-[20%] text-[#818589] text-[16px] px-6 py-3">{row.mobileNo ?? "--"}</td>
                      <td className="w-[20%] text-[#818589] text-[16px] px-6 py-3">{row.email ?? "--"}</td>

                      <td className="w-[20%] px-6 py-3">
                        <div className="flex  gap-3">

                          <div className="relative group inline-block">
                            <svg onClick={() => openViewUserModal(row)} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 cursor-pointer hover:border hover:border-white">
                              <path strokeLinecap="round" strokeLinejoin="round" d="M2.036 12.322a1.012 1.012 0 0 1 0-.639C3.423 7.51 7.36 4.5 12 4.5c4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639C20.577 16.49 16.64 19.5 12 19.5c-4.638 0-8.573-3.007-9.963-7.178Z" />
                              <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                            </svg>

                            <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block bg-black text-white text-[10px] px-2 py-1 rounded whitespace-nowrap z-50">
                              View user access
                            </span>
                          </div>

                          <div className="relative group inline-block">
                            <svg onClick={() => openEditModal(row)} className="size-5 cursor-pointer" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeWidth={1.5} d="M4 20l4-1 9-9-3-3-9 9-1 4z" />
                            </svg>
                            <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block bg-black text-white text-[10px] px-2 py-1 rounded whitespace-nowrap z-50">
                              Edit user access
                            </span>
                          </div>
                          <div className="relative group inline-block">
                            <svg onClick={() => openApproveRejectUserModal(row)} className="size-5 cursor-pointer" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeWidth={1.5} d="M5 13l4 4L19 7" />
                            </svg>
                            <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block bg-black text-white text-[10px] px-2 py-1 rounded whitespace-nowrap z-50">
                              Approve user
                            </span>
                          </div>
                          <div className="relative group inline-block">


                            <svg onClick={() => openRejectUserModal(row)} className="size-5 cursor-pointer" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeWidth={1.5} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                            <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block bg-black text-white text-[10px] px-2 py-1 rounded whitespace-nowrap z-50">
                              Reject user
                            </span>
                          </div>

                          <div className="relative group inline-block">
                            <svg onClick={() => openDeleteUserModal(row)} className="size-5 cursor-pointer" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeWidth={1.5} d="M6 7h12M9 7v12m6-12v12M5 7l1 14h12l1-14" />
                            </svg>
                            <span className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 hidden group-hover:block bg-black text-white text-[10px] px-2 py-1 rounded whitespace-nowrap z-50">
                              Delete user
                            </span>
                          </div>
                        </div>
                      </td>

                      <td className="w-[20%] text-[#818589] text-[16px] px-6 py-3">
                        {new Date(row?.requested_on).toLocaleString()}
                      </td>
                    </tr>
                  ))}
                </tbody>

              </table>
            </div>

          </div>
        )}
      </div>
      {viewUserForm && (
        <div className='z-[1000000] bg-[#00000066] h-[100vh] w-[100vw] fixed top-0 left-0 flex items-center justify-center '>
          <div className="modal-overlay w-[90%] max-w-[600px] h-[80%] bg-[#212529] relative overflow-y-auto">
            <div className="modal-content">
              <div className="bg-[#070d1b] pb-[1%] pt-[1%] items-center">
                <span onClick={closeBarModal} className="close-button cursor-pointer text-white text-[30px] flex justify-end mr-[3%]">
                  &times;
                </span>
              </div>
              <div className='mt-[1%] w-[97%] ml-[4%] mr-[5%]'>
                <div className="flex items-baseline w-[50%] justify-between p-[1%]">
                  <p className="text-[#ffffff] text-[20px] font-semibold">Name</p>
                  <p className="text-[#ffffff] text-[18px] font-light">{selectedUser?.name}</p>
                </div>
                <p className="text-[#ffffff] text-[20px] font-semibold mt-[2%] ml-[1%]">Requested Access for:</p>

                {/* Division */}
                <div className="flex items-baseline justify-between p-[1%] mt-[5%]">
                  <div className="w-[40%]">
                    <p className="text-[#ffffff] text-[20px] font-semibold">State </p>
                  </div>
                  <div className="w-[60%]">
                    <input type="text" className="w-[15.125rem] h-[5.15rem] rounded-tl-[0.25rem] rounded-bl-[0.25rem] focus:outline-none p-4" value="State" />
                  </div>
                </div>

                <div className="flex items-baseline justify-between p-[1%]">
                  <div className="w-[40%]">
                    <p className="text-[#ffffff] text-[20px] font-semibold">City</p>
                  </div>
                  <div className="w-[60%]">
                    <input type="text" className="w-[15.125rem] h-[5.15rem] rounded-tl-[0.25rem] rounded-bl-[0.25rem] focus:outline-none p-4" value="City" />

                  </div>

                </div>

                <div className="flex items-baseline justify-between p-[1%]">
                  <div className="w-[40%]">
                    <p className="text-[#ffffff] text-[20px] font-semibold">Taluka </p>
                  </div>
                  <div className="w-[60%]">
                    <input type="text" className="w-[15.125rem] h-[5.15rem] rounded-tl-[0.25rem] rounded-bl-[0.25rem] focus:outline-none p-4" value="Taluka" />
                  </div>

                </div>

                <div className="flex items-baseline justify-between p-[1%]">
                  <div className="w-[40%]">
                    <p className="text-[#ffffff] text-[20px] font-semibold">Village</p>
                  </div>

                  <div className="w-[60%]">
                    <input type="text" className="w-[15.125rem] h-[5.15rem] rounded-tl-[0.25rem] rounded-bl-[0.25rem] focus:outline-none p-4" value="Village" />
                  </div>
                </div>
                <div className="flex items-baseline mt-[1%] pt-[1%] justify-start 	" >
                </div>
                <div className="flex p-[1%] mt-[5%] justify-center">
                  <button className="bg-[#ED1849] text-[#FFFFFF] w-[123px] h-[44px]" onClick={() => editUserAccess(selectedUser)}>Save</button>
                  <button className="bg-[#212529] border border-[#ED1849] text-[#FFFFFF] w-[123px] h-[44px] ml-[2%]" onClick={closeBarModal}>Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}



      {/* ---------------------------------Reason for reject user ends------------------- */}

      {/* -------------------------FOR APPROVED REQUEST------------------------------- */}
      {activeTab === "Approved" && (
        <ApprovedReq approvedUserListData={approvedUserListData} handleSetUserForm={handleSetUserForm} setUserDetailFn={setUserDetailFn}
          handleSearchInputChange={handleSearchInputChange}
          updateUserListData={updateUserListData}
          searchInput={searchInput}

        />
      )}

      {activeTab === "Rejected" && (
        <RejectedReq approvedUserListData={rejectedUserListData} handleSetUserForm={handleSetUserForm} setUserDetailFn={setUserDetailFn} updateUserListData={updateUserListData} />

      )}

      {/* -------------------------FOR APPROVED REQUEST------------------------------- */}

      {/* -------------------------------------DELETE USER----------------------------------- */}
      {deletUserForm == true && (
        <div className='z-[1000000] bg-[#00000066] h-[100vh] w-[100vw] fixed top-0 left-0 flex items-center justify-center'>
          <div className="modal-overlay w-[90%] max-w-[600px] h-[50%] bg-[#000000] relative overflow-y-auto">
            <div className="modal-content">

              <div className=" bg-[#212529] pb-[1%] pt-[1%] items-center " >
                <span onClick={closeDetetedForm} className="close-button cursor-pointer text-white text-[30px] flex justify-end	mr-[3%]	">
                  &times;
                </span>
              </div>
              <div className='mt-[1%] text-center	 ml-[4%]' >
                <div className="p-[1%]	" >
                  <p className="text-[#ffffff] text-[20px] font-semibold	 ">Delete {selectedUsers.length} user(s)  </p>
                  <p className="text-[#ffffff] text-[16px] font-normal mt-[2%] ml-[1%] ">Are you sure you want to delete the </p>
                  <p className="text-[#ffffff] text-[16px] font-normal mt-[2%] ml-[1%] ">selected user(s) </p>
                </div>
                <div className="flex p-[1%] mt-[1%]  justify-center">
                  <button className="bg-[#ED1849] text-[#FFFFFF] w-[123px] h-[44px] mr-[2%]" onClick={handleDeleteUser} >Submit</button>
                  <button className="bg-[#212529] border border-[#ED1849] text-[#FFFFFF]  w-[123px] h-[44px]  " onClick={closeRejectUser} >Cancel</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* --------------------------------------section for add new user ----------------------------- */}
      {addNewUserForm && (
        <div className='z-[1000000] bg-[#00000066] h-[100vh] w-[100vw] fixed top-0 left-0 flex items-center justify-center'>
          <div className="modal-overlay w-[95%] max-w-[750px] h-[85vh] bg-[#f5f5f5] relative flex flex-col">
            <div className="flex flex-col h-full">
              {/* <div className="bg-[#000000] px-4 py-2 sticky top-0 z-10 rounded-t-lg shadow-md"> */}
              <div
                className="px-4 py-2 sticky top-0 z-10 shadow-md relative rounded-t-lg"
                style={{
                  backgroundImage: `url(${tableBg})`,
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center",
                  backgroundSize: "cover"
                }}
              >

                {/* Close Button */}
                <div className="flex justify-end">
                  <span
                    onClick={closeAddUserForm}
                    className="cursor-pointer text-white text-[22px] hover:text-gray-300 transition"
                  >
                    &times;
                  </span>
                </div>

                {/* Title */}
                <div className="text-center ">
                  <p className="text-white text-[22px] font-semibold">
                    Add New User
                  </p>
                  <p className="text-gray-300 text-[18px]">
                    Add user and assign roles
                  </p>
                </div>

              </div>
              {/* <div className='flex-1 overflow-y-auto mt-[1%] w-[92%] ml-[4%] pr-2 pb-[80px]'> */}
              <div className="flex-1 overflow-y-auto px-4 py-2">

                <div className="flex items-baseline  justify-start p-[1%] mt-[1%]	" >
                  <div className="w-[40%]" >
                    <p className="text-[black] text-[16px] font-normal	 ">Name *</p>
                  </div>
                  <div className="w-[40%]" >
                    <input id="user-name" type="text"
                      className="w-[18.125rem] h-[2.25rem] rounded-tl-[0.25rem] rounded-bl-[0.25rem] p-4 border border-[#808080] focus:outline-none focus:ring-[0.5] focus:ring-[#808080]"
                      placeholder="Enter name"
                      value={inputUserData?.userName}
                      onChange={(e) => {
                        handleChange("userName", e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="flex items-baseline  justify-start p-[1%] mt-[1%]	" >
                  <div className="w-[40%]" >
                    <p className="text-[black] text-[16px] font-normal	 ">Mobile Number *</p>
                  </div>
                  <div className="w-[40%]" >
                    <input
                      id="user-mobile"
                      type="number"
                      className="w-[18.125rem] h-[2.25rem] rounded-tl-[0.25rem] rounded-bl-[0.25rem] p-4 border border-[#808080] focus:outline-none focus:ring-[0.5] focus:ring-[#808080]"
                      placeholder="Enter Mobile Number"
                      value={inputUserData?.userMobile}
                      onChange={(e) => {
                        const { value } = e.target;
                        if (value.length < 10) {
                          setMobileNumberError("Please enter a valid mobile number.");
                          handleChange("userMobile", value);
                        } else if (value.length === 10 || value.length === 0) {
                          handleChange("userMobile", value);
                          setMobileNumberError("");
                        }

                      }}
                    />
                  </div>
                </div>

                <div className="flex items-baseline  justify-start p-[1%] mt-[1%]	" >
                  <div className="w-[40%]" >
                    <p className="text-[black] text-[16px] font-normal	 ">Email *</p>
                  </div>
                  <div className="w-[40%]" >
                    <input
                      id="user-email"
                      type="email"
                      className="w-[18.125rem] h-[2.25rem] rounded-tl-[0.25rem] rounded-bl-[0.25rem] p-4 border border-[#808080] focus:outline-none focus:ring-[0.5] focus:ring-[#808080]"
                      placeholder="Enter Email"
                      value={inputUserData?.userEmail}
                      onChange={(e) => {
                        handleChange("userEmail", e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="flex items-baseline  justify-start p-[1%] mt-[1%]	" >
                  <div className="w-[40%]" >
                    <p className="text-[black] text-[16px] font-normal	 ">Department *</p>
                  </div>
                  <div >
                    <input
                      id="user-department"
                      type="text"
                      className="w-[18.125rem] h-[2.25rem] rounded-tl-[0.25rem] rounded-bl-[0.25rem] p-4 border border-[#808080] focus:outline-none focus:ring-[0.5] focus:ring-black"
                      placeholder="Enter Department"
                      value={inputUserData?.userDepartment}
                      onChange={(e) => {
                        handleChange("userDepartment", e.target.value);
                      }}
                    />
                  </div>
                </div>
                <div className="flex items-baseline justify-start p-[1%] mt-[1%]">
                  <div className="w-[40%]">
                    <p className="text-black text-[16px] font-normal">Designation *</p>
                  </div>
                  <div className="w-[40%]">
                    <input
                      id="user-designation"
                      type="text"
                      className="w-[18.125rem] h-[2.25rem] rounded-tl-[0.25rem] rounded-bl-[0.25rem] p-4 border border-[#808080] focus:outline-none focus:ring-[0.5] focus:ring-[#808080]"
                      placeholder="Enter Designation"
                      value={inputUserData?.userDesignation}
                      onChange={(e) => {
                        handleChange("userDesignation", e.target.value);
                      }}
                    />
                  </div>
                </div>

                <div className="flex items-baseline justify-start p-[1%] mt-[1%]">
                  <div className="w-[40%]">
                    <p className="text-black text-[16px] font-normal">User Type *</p>
                  </div>
                  <div className="w-[40%]">
                    <select
                      className="w-[18.125rem] h-[2.25rem] border border-[#808080] rounded px-2"
                      value={inputUserData.userType}
                      onChange={(e) => handleChange("userType", Number(e.target.value))}
                    >
                      <option value={1}>Admin</option>
                      <option value={2}>User</option>
                    </select>
                  </div>
                </div>

                <div className="flex items-baseline justify-start p-[1%] mt-[1%]">
                  <div className="w-[40%]">
                    <p className="text-black text-[16px] font-normal">User Status *</p>
                  </div>
                  <div className="w-[40%]">
                    <select
                      className="w-[18.125rem] h-[2.25rem] border border-[#808080] rounded px-2"
                      value={inputUserData.userStatus}
                      onChange={(e) => handleChange("userStatus", Number(e.target.value))}
                    >
                      <option value={1}>Active</option>
                      <option value={0}>Inactive</option>
                    </select>
                  </div>
                </div>
                <div className="flex items-center p-[1%] mt-[1%]  justify-start 	" >
                  <div className="w-[40%]" >
                    <p className="text-[black] text-[16px] font-normal	 "> Feature Type *</p>
                  </div>
                  <div className="w-[40%]" >
                    <MultiSelect
                      enableSelectAll={true}
                      dropDownTitle={'Feature Type'}
                      options={featureTypesList}
                      value={selectedFeatureType}
                      onChange={(newValue) => {

                        const safeVal = newValue || [];
                        setSelectedFeatureType(safeVal);

                        const selectedFeatures = safeVal.map(opt => opt.value);

                        const farmFeatures = [
                          "farm-report",
                          "farmer-scorecard",
                          "crop-history",
                          "cadastral-data"
                        ];

                        const isFarm = selectedFeatures.some(f =>
                          farmFeatures.includes(f)
                        );

                        setSelectedLocation(prev => ({
                          ...prev,
                          country: [],
                          state: [],
                          city: [],
                          taluka: [],
                          village: []
                        }));

                        getLocationList(
                          `admin/webp/agbi_multi_location.php?type=country ${getFeatureParams()}`, "country"
                        );
                      }}
                    />
                  </div>
                </div>
                <div className="flex items-center p-[1%] mt-[1%]  justify-start 	" >
                  <div className="w-[40%]" >
                    <p className="text-[black] text-[16px] font-normal	 ">Country *</p>
                  </div>
                  <MultiSelect
                      enableSelectAll={true}
                    dropDownTitle="Country"
                    options={countryOptions}
                    value={selectedLocation.country}
                    isLoading={dropdownLoader.country}
                    // onChange={(val) => {
                    //   const ids = getIdsOrAll(val, countryOptions);
                    //   setSelectedLocation(prev => ({
                    //     ...prev,
                    //     country: val,
                    //     state: [],
                    //     city: [],
                    //     taluka: [],
                    //     village: [],
                    //     khasra: []
                    //   }));
                    //   getLocationList(buildParams("state", ids, "country_id"), "state");
                    // }}
                    onChange={(val) => {
                      const ids =
                        val?.some(item => item.value === "*") ? "*" : getIdsOrAll(val, countryOptions);

                      setSelectedLocation(prev => ({
                        ...prev,
                        country: val,
                        state: [],
                        city: [],
                        taluka: [],
                        village: [],
                        khasra: []
                      }));

                      getLocationList(buildParams("state", ids, "country_id"), "state");
                    }}
                  />

                </div>
                <div className="flex items-center p-[1%] mt-[1%]  justify-start 	" >
                  <div className="w-[40%]" >
                    <p className="text-[black] text-[16px] font-normal	 ">State *</p>
                  </div>
                  <MultiSelect
                    enableSelectAll={true}
                    dropDownTitle="State"
                    options={stateOptions}
                    value={selectedLocation.state}
                    isLoading={dropdownLoader.state}
                      //  onChange={(val) => {
                      //   const ids = getIdsOrAll(val, stateOptions);
                      //   setSelectedLocation(prev => ({
                      //     ...prev,
                      //     state: val,
                      //     city: [],
                      //     taluka: [],
                      //     village: [],
                      //     khasra: []
                      //   }));
                      //   getLocationList(buildParams("district", ids, "state_id"), "city");
                      // }}
                    onChange={(val) => {
                      const ids =
                        val?.some(item => item.value === "*") ? "*" : getIdsOrAll(val, stateOptions);

                      setSelectedLocation(prev => ({
                        ...prev,
                        state: val,
                        city: [],
                        taluka: [],
                        village: [],
                        khasra: []
                      }));

                      getLocationList(buildParams("district", ids, "state_id"), "city");
                    }}
                  />
                </div>
                <div className="flex items-center p-[1%]  mt-[1%] justify-start 	" >
                  <div className="w-[40%]" >
                    <p className="text-[black] text-[16px] font-normal	 ">City *</p>
                  </div>
                  <div >
                    <MultiSelect
                      enableSelectAll={true}
                      dropDownTitle="City"
                      options={cityOptions}
                      value={selectedLocation.city}
                      isLoading={dropdownLoader.city}
                      //     onChange={(val) => {
                      //   const ids = getIdsOrAll(val, cityOptions);
                      //   setSelectedLocation(prev => ({
                      //     ...prev,
                      //     city: val,
                      //     taluka: [],
                      //     village: [],
                      //     khasra: []
                      //   }));

                      //   getLocationList(buildParams("taluk", ids, "district_id"), "taluka");
                      // }}
                      onChange={(val) => {
                        const ids =
                          val?.some(item => item.value === "*") ? "*" : getIdsOrAll(val, cityOptions);

                        setSelectedLocation(prev => ({
                          ...prev,
                          city: val,
                          taluka: [],
                          village: [],
                          khasra: []
                        }));

                        getLocationList(buildParams("taluk", ids, "district_id"), "taluka");
                      }}
                    />
                  </div>
                </div>
                <div className="flex items-center p-[1%] mt-[1%] justify-start 	" >
                  <div className="w-[40%]" >
                    <p className="text-[black] text-[16px] font-normal	 ">Taluka *</p>
                  </div>
                  <div >
                    <MultiSelect
                      enableSelectAll={true}
                      dropDownTitle="Taluka"
                      options={talukaOptions}
                      value={selectedLocation.taluka}
                      isLoading={dropdownLoader.taluka}
                      //   onChange={(val) => {
                      //   const ids = getIdsOrAll(val, talukaOptions);
                      //   setSelectedLocation(prev => ({
                      //     ...prev,
                      //     taluka: val,
                      //     village: [],
                      //     khasra: []
                      //   }));
                      //   getLocationList(buildParams("village", ids, "taluk_id"), "village");
                      // }}
                      onChange={(val) => {
                        const ids =
                          val?.some(item => item.value === "*") ? "*" : getIdsOrAll(val, talukaOptions);

                        setSelectedLocation(prev => ({
                          ...prev,
                          taluka: val,
                          village: [],
                          khasra: []
                        }));

                        getLocationList(buildParams("village", ids, "taluk_id"), "village");
                      }}
                    />
                  </div>
                </div>
                <div className="flex items-baseline mt-[1%] p-[1%] justify-start 	" >
                  <div className="w-[40%]" >
                    <p className="text-[black] text-[16px] font-normal	 ">Village *</p>
                  </div>
                  <div >
                    <MultiSelect
                      enableSelectAll={true}
                      dropDownTitle="Village"
                      options={villageOptions}
                      value={selectedLocation.village}
                      isLoading={dropdownLoader.village}
                      // onChange={(val) => {
                      //   const ids = getIdsOrAll(val, villageOptions);

                      //   setSelectedLocation(prev => ({
                      //     ...prev,
                      //     village: val,
                      //     khasra: []
                      //   }));

                      //   getLocationList(buildParams("khasra", ids, "village_code"), "khasra");
                      // }}
                      onChange={(val) => {
                        const ids =
                          val?.some(item => item.value === "*") ? "*" : getIdsOrAll(val, villageOptions);

                        setSelectedLocation(prev => ({
                          ...prev,
                          village: val,
                          khasra: []
                        }));

                        getLocationList(buildParams("khasra", ids, "village_code"), "khasra");
                      }}

                    />
                  </div>
                </div>
                <div className="flex items-baseline mt-[1%] p-[1%] justify-start 	" >
                  <div className="w-[40%]" >
                    <p className="text-[black] text-[16px] font-normal	 ">Khasra *</p>
                  </div>
                  <div >
                    <MultiSelect
                      enableSelectAll={true}
                        dropDownTitle="Khasra"
                  options={khasraOptions}
                  value={selectedLocation.khasra}
                      isLoading={dropdownLoader.khasra}
                      // onChange={(val) => {
                      //   setSelectedLocation(prev => ({
                      //     ...prev,
                      //     khasra: val || []
                      //   }));
                      // }}
                      onChange={(val) => {
                        const ids = val?.some(item => item.value === "*")
                          ? ["*"]
                          : val.map(v => v.value);

                        setSelectedLocation(prev => ({
                          ...prev,
                          khasra: val || []
                        }));
                      }}
                    />
                  </div>
                </div>
                <div className="flex p-[1%] mt-[5%] justify-center">
                  <button className="bg-[#2e9ce6] text-[#FFFFFF] w-[123px] h-[44px] " onClick={addNewUser} >Submit</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* --------------------------------------section for approve or reject ----------------------------- */}
      {approveRejectUser && (
        <div className="z-[1000000] bg-[#00000066] fixed top-0 left-0 w-[100vw] h-[100vh] flex items-center justify-center">
          <div className="w-[80%] max-w-[600px] rounded-lg overflow-hidden shadow-lg bg-white flex flex-col">
            <div
              className="flex justify-between items-center px-6 h-[80px]"
              style={{
                backgroundImage: `url(${tableBg})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "cover"
              }}
            >
              <p className="text-white text-[26px] font-semibold m-0">
                Approve User
              </p>

              <span
                onClick={closeAppproveRejectUserModal}
                className="text-white text-[28px] cursor-pointer"
              >
                &times;
              </span>
            </div>

            {/* Content */}
            <div className="p-6 text-center">

              <p className="text-black text-[18px] mb-6">
                Do you want to approve?
              </p>

              <div className="flex justify-center gap-4">
                <button
                  className="bg-[#2f9ce6] text-white w-[123px] h-[44px] rounded-md"
                  onClick={() => approveUserRequest(selectedUser, "1")}
                >
                  Approve
                </button>

                <button
                  className="border border-[#2f9ce6] text-[#2f9ce6] w-[123px] h-[44px] rounded-md"
                  onClick={closeAppproveRejectUserModal}
                >
                  Cancel
                </button>
              </div>

            </div>

          </div>
        </div>
      )}
      {showRejectUser && (
        <div className="z-[1000000] bg-[#00000066] fixed top-0 left-0 w-[100vw] h-[100vh] flex items-center justify-center">
          <div className="w-[80%] max-w-[600px] rounded-lg overflow-hidden shadow-lg bg-white flex flex-col">
            <div
              className="flex justify-between items-center px-6 h-[80px]"
              style={{
                backgroundImage: `url(${tableBg})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "cover"
              }}
            >
              <p className="text-white text-[26px] font-semibold m-0">Reject User</p>
              <span
                onClick={closeRejectUserModal}
                className="text-white text-[28px] cursor-pointer"
              >
                &times;
              </span>
            </div>
            <div className="p-6 text-center">
              <p className="text-black text-[18px] mb-6">Do you want to reject?</p>
              <div className="flex justify-center gap-4">
                <button
                  className="bg-[#2f9ce6] text-white w-[123px] h-[44px] rounded-md"
                  onClick={() => approveUserRequest(selectedUser, "2")}
                >
                  Reject
                </button>
                <button
                  className="border border-[#2f9ce6] text-[#2f9ce6] w-[123px] h-[44px] rounded-md"
                  onClick={closeRejectUserModal}
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {deleteUser && (
        <div className="z-[1000000] bg-[#00000066] fixed top-0 left-0 w-[100vw] h-[100vh] flex items-center justify-center">

          <div className="w-[80%] max-w-[600px] rounded-lg overflow-hidden shadow-lg bg-white flex flex-col">

            <div
              className="flex justify-between items-center px-6 h-[80px]"
              style={{
                backgroundImage: `url(${tableBg})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "cover"
              }}
            >
              <p className="text-white text-[26px] font-semibold m-0">
                Delete User
              </p>

              <span
                onClick={closeDeleteUserModal}
                className="text-white text-[28px] cursor-pointer"
              >
                &times;
              </span>
            </div>

            <div className="p-6 text-center">

              <p className="text-black text-[18px] mb-6">
                Do you want to delete the user?
              </p>

              <div className="flex justify-center gap-4">
                <button
                  className="bg-[#2f9ce6] text-white w-[123px] h-[44px] rounded-md"
                  onClick={() => deleteUserRequest(selectedUser)}
                >
                  Confirm
                </button>

                <button
                  className="border border-[#2f9ce6] text-[#2f9ce6] w-[123px] h-[44px] rounded-md"
                  onClick={closeDeleteUserModal}
                >
                  Cancel
                </button>
              </div>

            </div>

          </div>
        </div>
      )}
      {/* modal for view user */}

      {viewUser && (
        <div className="z-[1000000] bg-[#00000066] fixed top-0 left-0 w-[100vw] h-[100vh] flex items-center justify-center">
          <div className="w-[80%] max-w-[600px] rounded-lg overflow-hidden shadow-lg bg-white flex flex-col">

            <div
              className="flex justify-between items-center px-6 h-[80px]"
              style={{
                backgroundImage: `url(${tableBg})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "cover"
              }}
            >
              <p className="text-white text-[26px] font-semibold m-0">
                View User Access
              </p>

              <span
                onClick={closeViewUserModal}
                className="text-white text-[28px] cursor-pointer"
              >
                &times;
              </span>
            </div>
            <div className="px-6 py-3 bg-gray-100 border-b">
              <p className="text-black text-[18px] font-semibold">
                {selectedUser?.name}
              </p>
              <p className="text-gray-700 text-[18px]">
                📱 {selectedUser?.mobileNo}
              </p>
              <p className="text-gray-500 text-[18px]">
                {selectedUser?.email}
              </p>
            </div>
            <div className="p-4 max-h-[400px] overflow-y-auto">
              <TreeView selectedUserId={selectedUserId}  selectedUserData={selectedUser} />
            </div>

          </div>
        </div>
      )}

      {/* end of view user modal */}
      {viewEditModal && (
       <div className="z-[1000000] bg-[#00000066] fixed top-0 left-0 w-[100vw] h-[100vh] flex items-center justify-center">
    <div className="w-[80%] max-w-[600px] max-h-[90vh] rounded-lg shadow-lg bg-white flex flex-col relative">
      <div
        className="flex items-center justify-between px-6 h-[80px] shrink-0"
        style={{
          backgroundImage: `url(${tableBg})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          backgroundSize: "cover"
        }}
      >
        <p className="text-white text-[22px] font-semibold">
          Edit User Access
        </p>

        <span
          onClick={closeEditModal}
          className="text-white text-[26px] cursor-pointer hover:scale-110 transition"
        >
          ×
        </span>
      </div>
      <div className="p-4 overflow-y-auto flex-1">
        <EditUser
          selectedUserId={selectedUserId}
          closeEditModal={closeEditModal}
          selectedUserData={selectedUser}
        />
      </div>

    </div>
  </div>
      )}
    </div>
  )
}

export default UsersList;